import { ROUTE, axiosInstance } from '@/core/api/axiosInstance';
import type {
  GetReportsByDateRangeParams,
  RegionReportSection,
  ReportAvailablePeriod,
  ReportSummarySection,
} from '@/server/services/GoogleBigQuery/BigQueryForecastReportsClient.types';

export const dashboard = {
  getReportsSummary: async ({ dateFrom, dateTo }: { dateFrom: string; dateTo?: string }) => {
    const { data } = await axiosInstance.get<ReportSummarySection[]>(ROUTE.DASHBOARD.REPORTS_SUMMARY, {
      params: { dateFrom, dateTo, includeDocument: true } as GetReportsByDateRangeParams,
    });
    return data;
  },

  getReportsSummaryRanges: async () => {
    const { data } = await axiosInstance.get<ReportAvailablePeriod[]>(ROUTE.DASHBOARD.REPORTS_SUMMARY_RANGES);
    return data;
  },

  getReportsRegionSections: async ({ dateFrom, dateTo }: { dateFrom: string; dateTo?: string }) => {
    const { data } = await axiosInstance.get<RegionReportSection[]>(ROUTE.DASHBOARD.REPORTS_SECTIONS, {
      params: { dateFrom, dateTo },
    });
    return data;
  },
};
